import React, { Component } from 'react';
import CookieCategory from '../../models/CookieCategory';
import CookieBannerConfiguration from '../../models/CookieBannerConfiguration'

type CookieCategoryManagementViewProps = {
    cookieBannerConfiguration: CookieBannerConfiguration,
    cookieCategory: CookieCategory
    consentChanged: (accepted: boolean) => void
    index: number
}

export default class CookieCategoryManagementView extends Component<CookieCategoryManagementViewProps, any> {
    private firstButtonRef: React.RefObject<HTMLButtonElement> = React.createRef();

    componentDidMount() {
        //put focus to first button with button not disabled, see this.props.cookieCategory.isRequired
        if (this.props.index === 0 && this.firstButtonRef.current) {
            this.firstButtonRef.current.focus();
        }
    }

    public render() {
        return (
            <div className='mx-0 mt-1 mb-2 my-md-3'>
                <div className="d-flex flex-column flex-md-row">
                    <div className='d-flex align-items-start'>
                        {
                            this.props.cookieCategory.isRequired &&
                            <React.Fragment>
                                <button type="button" className='btn btn-primary btn-sm mr-2' disabled={true}>
                                    {this.props.cookieBannerConfiguration.acceptCategoryButtonText}
                                </button>
                                <button type="button" className='btn btn-sm mr-2 visibility-hidden' disabled={true}>
                                    {this.props.cookieBannerConfiguration.declineCategoryButtonText}
                                </button>
                            </React.Fragment>
                        }
                        {
                            !this.props.cookieCategory.isRequired &&
                            <React.Fragment>
                                <button ref={this.firstButtonRef} type="button" className={'btn btn-sm mr-2' + (this.props.cookieCategory.hasConcent ? ' btn-primary' : ' btn-outline-secondary')}
                                    onClick={() => this.props.consentChanged(true)}
                                    disabled={this.props.cookieCategory.isRequired}>
                                    {this.props.cookieBannerConfiguration.acceptCategoryButtonText}
                                </button>
                                <button type="button" className={'btn btn-sm mr-2' + (!this.props.cookieCategory.hasConcent ? ' btn-primary' : ' btn-outline-secondary')}
                                    onClick={() => this.props.consentChanged(false)}
                                    disabled={this.props.cookieCategory.isRequired}>
                                    {this.props.cookieBannerConfiguration.declineCategoryButtonText}
                                </button>
                            </React.Fragment>
                        }
                    </div>
                    <div>
                        <p className='font-weight-bolder text-small mb-0'>{this.props.cookieCategory.title}</p>
                        <span dangerouslySetInnerHTML={{ __html: this.props.cookieCategory.description }} className='d-block text-md-small text-smaller u-mb-gamma u-ms-1'></span>
                    </div>
                </div>
            </div>
        );
    }
}